import styled from "styled-components";

import { colors } from "../../../constants/colors";

export type StyledInputTextProps = {
  height?: string;
  width?: string;
};

export const StyledInputText = styled.input`
  background: ${colors.form.background};
  font-size: 16px;
  height: ${({ height }: StyledInputTextProps) => height || "2rem"};
  width: ${({ width }: StyledInputTextProps) => width || "10rem"};
  padding: 0.5rem;
  box-sizing: border-box;
  border-radius: 5px;
  border: 0px;

  &:disabled {
    background: ${colors.disable};
  }

  &:focus {
    background: ${colors.form.focused};
  }
`;
